<template>
	<div class="trapezoid-container">
		<div class="trapezoid trapezoid1" :class="'trapezoid1-'+$t('theme.title')">
			<div class="download-buttons">
				<h1>{{ $t('download.title') }}</h1>
				<p>{{ $t('download.content') }}</p>
				<div class="code" id="qrcode" ref="qrcode" v-if="IsPC()"></div>
				<div v-else>
					<a :href="iosDownloadUrl || 'javascript:void(0)'" class="download-btn ios-btn" @click.prevent="handleDownload('ios')">
						<i class="fab fa-apple"></i>
						{{ $t('smartHome.downloadIOS') }}
					</a>
					<a :href="androidDownloadUrl || 'javascript:void(0)'" class="download-btn android-btn" @click.prevent="handleDownload('android')">
						<i class="fab fa-android"></i>
						{{ $t('smartHome.downloadAndroid') }}
					</a>
				</div>
			</div>
		</div>
		<div class="trapezoid trapezoid2">
			<img :src="require('../assets/down/down2-'+$t('theme.title')+'.png')" />
			<div class="content">
				<h2>{{ $t('download.title2') }}</h2>
				<p>{{ $t('download.content2') }}</p>
			</div>
		</div>
		<div class="trapezoid trapezoid3" :class="'trapezoid3-'+$t('theme.title')">
			<div class="content">
				<h2>{{ $t('download.title3') }}</h2>
				<p>{{ $t('download.content3') }}</p>
			</div>
		</div>
		<div class="trapezoid trapezoid4">
			<img :src="require('../assets/down/down4-'+$t('theme.title')+'.png')" />
			<div class="content content4">
				<h2>{{ $t('download.title4') }}</h2>
				<p>{{ $t('download.content4') }}</p>
			</div>
		</div>
		<div class="trapezoid trapezoid6">
			<img :src="require('../assets/down/down5-'+$t('theme.title')+'.png')" />
			<div class="content">
				<h2>{{ $t('download.title5') }}</h2>
				<p>{{ $t('download.content5') }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import QRcode from 'qrcodejs2'
import codelogoZH from '../assets/codelogo-zh.png'
import codelogoEN from '../assets/codelogo-en.png'
export default {
	data() {
		return {
			browserLanguage: '',
			current: 1, // 0:海外, 1:国内
			iosDownloadUrl: '',
			androidDownloadUrl: '',
			urlObj: null,
			config: [
				{
					dataCenterType: 0,
					publicAppId: 'usx07yqia4diqi', // 海外
					apiPath: 'https://service.hellobabysmart.com/api',
					logo: '../static/logo_en.png',
					android: '../static/android_en.png',
					ios: '../static/ios_en.png'
				},
				{
					dataCenterType: 1,
					publicAppId: 'cnla3t0a8tqm7t', //国内
					apiPath: 'https://service.rinoiot.com/api',
					logo: '../static/logo_cn.png',
					android: '../static/android_cn.png',
					ios: '../static/ios_cn.png'
				}
			],
			cacheKey: 'download_config_cache',
			cacheExpire: 24 * 60 * 60 * 1000, // 24小时缓存有效期
			isLoading: false
		};
	},
	created() {
		this.checkCache();
	},
	mounted() {
		this.browserLanguage = (navigator.browserLanguage || navigator.language).toLowerCase(); // 获取浏览器语言
		if(this.IsPC()){
			this.generateQRCode();
		}
		
	},
	watch: {
		'$i18n.locale': {
			handler(newLocale) {
				// 当语言切换时，重新生成二维码
				if (this.urlObj && this.IsPC()) {
					this.generateQRCode();
				}
			},
			deep: true
		}
	},
	methods: {
		generateQRCode() {
			if (!this.urlObj) return;
			// 修改二维码指向，使用新的AppDownload页面
			const baseUrl = window.location.origin;
			const appDownloadUrl = `${baseUrl}/#/app-download`;

			console.log('二维码指向:', appDownloadUrl);

			// 先清空二维码容器，销毁之前的二维码
			this.$refs.qrcode.innerHTML = '';

			new QRcode(this.$refs.qrcode, {
				text: appDownloadUrl,
				width: 300,
				height: 300,
				colorDark: this.$i18n.locale == 'en' ? '#FE5E10' : '#30B4E9',
				colorLight: '#ffffff'  // 设置背景颜色为白色
			})

			// 在二维码中间添加logo图片
			this.$nextTick(() => {
				// 检查是否已存在logo，如果有则移除
				const existingLogo = this.$refs.qrcode.querySelector('.qrcode-logo');
				if (existingLogo) {
					existingLogo.remove();
				}
				
				// 创建logo元素
				const logoImg = document.createElement('img');
				logoImg.src = this.$i18n.locale == 'en' ? codelogoEN : codelogoZH;
				logoImg.className = 'qrcode-logo';
				logoImg.style.position = 'absolute';
				logoImg.style.top = '50%';
				logoImg.style.left = '50%';
				logoImg.style.transform = 'translate(-50%, -50%)';
				logoImg.style.width = '50px';
				logoImg.style.height = '50px';
				logoImg.style.backgroundColor = 'white';
				logoImg.style.borderRadius = '4px';
				logoImg.style.padding = '2px';
				logoImg.style.zIndex = '10';
				
				// 添加logo到二维码容器
				this.$refs.qrcode.style.position = 'relative';
				this.$refs.qrcode.appendChild(logoImg);
			});
		},
		// 检查本地缓存
		checkCache() {
			try {
				const cacheStr = localStorage.getItem(this.cacheKey);
				if (!cacheStr) return false;

				const cacheData = JSON.parse(cacheStr);
				if (Date.now() - cacheData.timestamp < this.cacheExpire) {
					this.urlObj = cacheData.data;
					this.current = cacheData.region;
					this.preFetchDownloadUrls();
					return true;
				}
				localStorage.removeItem(this.cacheKey);
				return false;
			} catch (e) {
				return false;
			}
		},
		IsPC() {
			var userAgentInfo = navigator.userAgent;
			var Agents = ["Android", "iPhone",
				"SymbianOS", "Windows Phone", "iPad", "iPod"
			];
			var flagPc = true;
			for (var v = 0; v < Agents.length; v++) {
				if (userAgentInfo.indexOf(Agents[v]) > 0) {
					flagPc = false;
					break;
				}
			}
			return flagPc;
		},
		saveToCache() {
			try {
				const cacheData = {
					data: this.urlObj,
					region: this.current,
					timestamp: Date.now()
				};
				localStorage.setItem(this.cacheKey, JSON.stringify(cacheData));
			} catch (e) {}
		},

		async initDownloadConfig() {
			if (this.isLoading) return;

			this.isLoading = true;
			try {
				await this.getIP();

				await this.fetchDownloadConfig(this.config[this.current].publicAppId);

				this.saveToCache();
			} catch (error) {
				this.preFetchDownloadUrls();
			} finally {
				this.isLoading = false;
			}
		},

		requestUrl(id) {
			return `${this.config[this.current].apiPath}/business-app/v1/h5/getDownloadConfig/${id || ''}`;
		},

		async fetchDownloadConfig(id) {
			try {
				const response = await fetch(this.requestUrl(id), {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					}
				});

				if (!response.ok) {
					throw new Error('Network response was not ok');
				}

				const res = await response.json();
				this.urlObj = res.data || {};
				this.preFetchDownloadUrls();
			} catch (err) {
				throw err;
			}
		},

		async preFetchDownloadUrls() {
			if (!this.urlObj) return;
			const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

			let iosUrl = '';
			let androidUrl = '';

			iosUrl = this.urlObj.appStoreUrl;

			if (!isMobile) {
				if (this.current === 0 && this.urlObj.googleStoreUrl) {
					androidUrl = this.urlObj.googleStoreUrl;
				} else {
					androidUrl = this.urlObj.tencentStoreUrl;
				}
			} else {
				const brandChecks = [
					{ check: this.isHuawei, urlKey: 'huaweiStoreUrl' },
					{ check: this.isXiaomi, urlKey: 'xiaomiStoreUrl' },
					{ check: this.isVivo, urlKey: 'vivoStoreUrl' },
					{ check: this.isOppo, urlKey: 'oppoStoreUrl' }
				];

				let foundBrandUrl = null;
				for (const { check, urlKey } of brandChecks) {
					if (check.call(this) && this.urlObj[urlKey]) {
						foundBrandUrl = this.urlObj[urlKey];
						break;
					}
				}

				androidUrl = foundBrandUrl || this.urlObj.tencentStoreUrl;

				if (this.current === 0 && !foundBrandUrl && this.urlObj.googleStoreUrl) {
					androidUrl = this.urlObj.googleStoreUrl;
				}
			}

			this.$nextTick(() => {
				this.iosDownloadUrl = iosUrl || 'javascript:void(0)';
				this.androidDownloadUrl = androidUrl || 'javascript:void(0)';
			});
		},

		getIP() {
			return new Promise((resolve, reject) => {
				if (typeof this.current !== 'undefined' && [0, 1].includes(this.current)) {
					resolve();
					return;
				}

				fetch('https://ipinfo.io/json')
					.then((response) => {
						if (!response.ok) {
							throw new Error('Network response was not ok');
						}
						return response.json();
					})
					.then((data) => {
						this.current = data && data.country === 'CN' ? 1 : 0;
						resolve();
					})
					.catch((error) => {
						this.current = this.browserLanguage.includes('zh') ? 1 : 0;
						resolve();
					});
			});
		},

		// 设备检测方法保持不变
		isIos() {
			const userAgent = window.navigator.userAgent || '';
			const isIosDevice = /iPhone|iPad|iPod|Macintosh/i.test(userAgent) && 'ontouchend' in document;
			return !!isIosDevice;
		},

		isAndroid() {
			const userAgent = window.navigator.userAgent || '';
			return userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1;
		},

		isHuawei() {
			const userAgentStr = navigator.userAgent.toLowerCase();
			return userAgentStr.includes('huawei') || userAgentStr.includes('honor');
		},

		isXiaomi() {
			const userAgentStr = navigator.userAgent.toLowerCase();
			return (
				userAgentStr.includes('mi ') ||
				userAgentStr.includes('mix ') ||
				userAgentStr.includes('redmi') ||
				userAgentStr.includes('xiaomi') ||
				userAgentStr.includes('m2012k11ac')
			);
		},

		isVivo() {
			const userAgentStr = navigator.userAgent.toLowerCase();
			return userAgentStr.includes('vivo');
		},

		isOppo() {
			const userAgentStr = navigator.userAgent.toLowerCase();
			return userAgentStr.includes('oppo') || userAgentStr.includes('pacm00') || userAgentStr.includes('pbem00');
		},

		handleDownload(platform) {
			const url = platform === 'ios' ? this.iosDownloadUrl : this.androidDownloadUrl;

			if (!url || url === 'javascript:void(0)') {
				console.error('下载地址不可用');
				return;
			}

			window.location.href = url;
		}
	}
};
</script>

<style scoped>
.trapezoid-container{
	background-color: #ffffff;
}

.trapezoid {
	position: relative;
	width: 100%;
	aspect-ratio: 1920/751;
	min-height: 450px;
	margin-top: calc(-0.15 * max(100% * 751 / 1920, 450px));
	background-color: #ffffff;
}

.trapezoid1 {
	margin: 0px;
	z-index: 60;
	clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 85%);
	height: 950px;
	text-align: center;
	align-content: center;
}

.trapezoid1-zh{
	background-image: url('../assets/down/down1-zh.png');
}

.trapezoid1-en{
	background-image: url('../assets/down/down1-en.png');
}

.download-buttons {
	transform: rotateY(0) translateY(-5%) translateX(20%);

	width: fit-content;
	margin: 0 auto;

	display: flex;
	flex-direction: column;
	text-align: left;
	gap: 15px;
}

/* .download-buttons {
	transform: rotateY(0) translateY(-15%) translateX(10%);

	width: fit-content;
	margin: 0 auto;

	display: flex;
	flex-direction: column;
	text-align: left;
	gap: 15px;
} */

.download-buttons h1 {
	color: var(--active-nav-color);
	font-size: clamp(40px, 5.2vw, 100px);
}

.download-buttons p {
	color: #999999;
	font-size: clamp(24px, 3.75vw, 72px);
	letter-spacing: 13px;
}

.download-buttons a {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 274px;
	padding: 18px 35px;
	border-radius: 12px;
	text-decoration: none;
	font-weight: 500;
	transition: all 0.3s ease;

	background-color: #a6b8c6;
	color: #ffffff;
}

.download-buttons a:hover {
	opacity: 0.9;
	transform: translateY(-3px);
}

.trapezoid2 {
	z-index: 50;
	clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 85%);
}

img {
	position: absolute;
	min-width: 135px;
	width: 18%;

	bottom: 0;

	max-height: 83%;

	object-fit: cover;
	object-position: top;
	height: auto;
	aspect-ratio: attr(width) / attr(height);
}

.trapezoid2 img {
	right: 12.5%;
}

.content {
	position: absolute;
	line-height: 1.6;

	width: 40%;
	/* max-width: 500px; */

	text-align: left;
	padding-bottom: 3%;

	top: 50%;
	transform: translateY(-50%);
}

.content4{
	width: 50%;
}

.trapezoid2 .content {
	left: 13%;
}

.content h2 {
	color: #333;
	font-size: clamp(27px, 5.2vw, 54px);
}

.content p {
	color: #333;
	font-size: clamp(18px, 3.75vw, 22px);
	margin-top: 50px;
}

.trapezoid3 {
	z-index: 40;
	clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 85%);
}

.trapezoid3-zh{
	background-image: url('../assets/down/down3-zh.png');
}

.trapezoid3-en{
	background-image: url('../assets/down/down3-en.png');
}

.trapezoid3 .content {
	right: 10%;
}

.trapezoid4 {
	z-index: 30;
	clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 85%);
}

.trapezoid5 {
	z-index: 20;
	clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 85%);
}

.trapezoid6 {
	z-index: 10;
	background: linear-gradient(180deg, #e7ecf2 0%, #f9ebea 100%);
}

.trapezoid4 img {
	right: 12.5%;
}

.trapezoid4 .content {
	left: 10%;
}

.trapezoid6 img {
	left: 12.5%;
}

.trapezoid6 .content {
	right: 15%;
}

.code {
  width: 320px;
  border-radius: 8px;
  margin: 80px 0 0 400px;
  padding: 10px; /* 边框宽度 */
  background-color: white;
  display: inline-block;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 可选：添加阴影效果 */
}

@media (max-width: 768px) {
	.download-buttons{
		margin: 0;
		transform: rotateY(0) translateY(-16%) translateX(20%);
	}

	.download-buttons a{
		margin-top: 20px;
	}

	.trapezoid{
		height: 200px;
		background-size: cover;
	}

	.content,.content4{
		width: 80%;
	}
}
</style>
